import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { ERROR_EXPIRED_TOKEN, ERROR_INVALID_TOKEN } from '../constants'

import { getToken, logout } from './users'
import { router } from '../router/index'
import store from '../store/index'

const publicEndpoints = [{
  method: 'post',
  url: new RegExp(/auth\/login$/i)
}, {
  method: 'post',
  url: new RegExp(/contact$/i)
}, {
  method: 'put',
  url: new RegExp(/newsletters\/[\D]+\/unsubscribe$/i)
}, {
  method: 'get',
  url: new RegExp(/occupations\/stat\/(adverts|employersearch)$/i)
}, {
  method: 'get',
  url: new RegExp(/stat\/(adwatches\/aggregated|users|worklocations)$/i)
}, {
  method: 'get',
  url: new RegExp(/stat\/adwatches\/[\D]+\/cities$/i)
}, {
  method: 'post',
  url: new RegExp(/users$/i)
}, {
  method: 'put',
  url: new RegExp(/users\/[\D]+\/activate$/i)
}, {
  method: 'post',
  url: new RegExp(/users\/[\D]+\/resetpassword$/i)
}, {
  method: 'put',
  url: new RegExp(/users\/[\D]+\/resetpassword$/i)
}]

export function interceptRequest (config) {
  if (publicEndpoints.find(endpoint => endpoint.method === config.method && endpoint.url.test(config.url))) {
    return config
  }

  let token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}

function interceptErrorResponse (error) {
  const isForbidden = /403/g.test(error)
  const isInvalidToken = error.response && error.response.data
    ? (error.response.data.message === ERROR_INVALID_TOKEN || error.response.data.message === ERROR_EXPIRED_TOKEN)
    : false

  if (isForbidden || isInvalidToken) {
    logout()
    router.push('/', () => {
      store.dispatch('logout')
    })
  }

  return Promise.reject(error)
}

export function createHttp () {
  let instance = axios.create({ baseURL: process.env.API_URL })
  instance.interceptors.request.use(interceptRequest)
  instance.interceptors.response.use(null, interceptErrorResponse)

  Vue.use(VueAxios, instance)
}



// WEBPACK FOOTER //
// ./src/services/index.js